import { cloneDeep } from 'lodash-es';

/**
 * Does a deep clone of the object passed in.
 * @param obj
 * @returns
 */
export const typedClone = <T = unknown>(obj: T | undefined): T => {
	return cloneDeep(obj) as T;
};
